import RegisterEmail from "./containers/RegisterEmail";
import Entrance from "../../layouts/Entrance";
import VerifyEmail from "./containers/VerifyEmail";
import VerifyPhoneNumber from "./containers/VerifyPhoneNumber";
import PersonalInfo from "./containers/PersonalInfo";
import styles from './style.module.scss';
import WorkExperience from "./containers/WorkExperience";
import Education from "./containers/Education";
import Expertise from "./containers/Expertise";
import UploadFiles from "./containers/UploadFiles";
import { useDispatch, useSelector } from "../../store/store";
import ReviewInfo from "./containers/ReviewInfo";
import UploadProfilePhoto from "./containers/UploadProfilePhoto";
import UseSignInForm from "./containers/UseSignInForm";
import UploadPersonalID from "./containers/UploadPersonalID";
import CreatePassword from "./containers/CreatePassword";
import { TypographyLogo } from "../../assets/icons/common";
import Stepper from "../../components/Stepper";
import { useLocation } from "react-router-dom";
import Approval from "./containers/Approval";
import { useEffect, useState } from "react";
// import { signUpFlow } from "../../config";
import Legal from "./containers/Legal";
import KYC from "./containers/KYC";
import {
    selectLegalModal,
    selectSignUpStep,
} from "../../store/signUp/selectors";
import {
    setIDPhoto,
    setSignUpStep,
    setPersonalInfo,
    setPhoneNumberDisable,
} from "../../store/signUp/slice";

function SignUpPage() {
    const dispatch = useDispatch();
    const location = useLocation();
    const from = location?.state?.from;
    const step = useSelector(selectSignUpStep);
    const legalModal = useSelector(selectLegalModal);
    const [currentStep, setCurrentStep] = useState(1);
    const [resumeFile, setResumeFile] = useState<File | null>(null);
    const [personalPhoto, setPersonalPhoto] = useState<File | null>(null);
    const [portfolioFile, setPortfolioFile] = useState<File | null>(null);
    const [coverLetterFile, setCoverLetterFile] = useState<File | null>(null);
    const [certificateFile, setCertificateFile] = useState<File | null>(null);

    const isFullScreen =
        step === 'personalInfo' ||
        step === 'workExperience' ||
        step === 'education' ||
        step === 'expertise' ||
        step === 'uploadFiles' ||
        step === 'reviewInfo' ||
        step === 'uploadProfilePhoto' ||
        step === 'uploadPersonalID' ||
        step === 'KYC' ||
        step === 'approval' ||
        step === 'verifyPhoneNumber';

    const steps = {
        registerEmail: {
            title: '',
            component: <RegisterEmail />,
        },
        createPassword: {
            title: '',
            component: <CreatePassword />,
        },
        useSignInForm: {
            title: '',
            component: <UseSignInForm />
        },
        verifyEmail: {
            title: '',
            component: <VerifyEmail />,
        },
        verifyPhoneNumber: {
            title: '',
            component: <VerifyPhoneNumber />,
        },
        personalInfo: {
            title: 'Personal information',
            component: <PersonalInfo />,
        },
        workExperience: {
            title: 'Work experience',
            component: <WorkExperience />,
        },
        education: {
            title: 'Education',
            component: <Education />,
        },
        expertise: {
            title: 'Your expertise',
            component: <Expertise />,
        },
        uploadFiles: {
            title: 'Upload files',
            component: <UploadFiles
                resumeFile={resumeFile}
                portfolioFile={portfolioFile}
                coverLetterFile={coverLetterFile}
                certificateFile={certificateFile}
                setResumeFile={setResumeFile}
                setPortfolioFile={setPortfolioFile}
                setCertificateFile={setCertificateFile}
                setCoverLetterFile={setCoverLetterFile}
            />,
        },
        reviewInfo: {
            title: '',
            component: <ReviewInfo
                resumeFile={resumeFile}
                portfolioFile={portfolioFile}
                coverLetterFile={coverLetterFile}
                certificateFile={certificateFile}
            />,
        },
        uploadProfilePhoto: {
            title: 'Face photo',
            component: <UploadProfilePhoto file={personalPhoto} setFile={setPersonalPhoto} />,
        },
        uploadPersonalID: {
            title: 'ID photo',
            component: <UploadPersonalID />,
        },
        KYC: {
            title: '',
            component: <KYC />,
        },
        approval: {
            title: '',
            component: <Approval from={from} />
        }
    };

    useEffect(() => {
        return () => {
            dispatch(setSignUpStep('registerEmail'));
            dispatch(setPersonalInfo(null));
            dispatch(setIDPhoto(null));
            dispatch(setPhoneNumberDisable(false));
        }
    }, []);

    useEffect(() => {
        switch (step) {
            case 'personalInfo':
                setCurrentStep(1);
                break;
            case 'verifyPhoneNumber':
                setCurrentStep(2);
                break;
            case 'uploadProfilePhoto':
                setCurrentStep(3);
                break;
            case 'uploadPersonalID':
                setCurrentStep(4);
                break;
            case 'workExperience':
                setCurrentStep(5);
                break;
            case 'education':
                setCurrentStep(6);
                break;
            case 'expertise':
                setCurrentStep(7);
                break;
            case 'uploadFiles':
                setCurrentStep(8);
                break;
            default:
                return;
        }
    }, [step]);

    return (
        <Entrance fullScreenMode={isFullScreen}>
            <div className={styles.main}>
                <div className={styles.head}>
                    <TypographyLogo width={280} height={70} />
                    <span className={styles.head_devider} />
                    <span className={styles.head_title}>Sign up</span>
                </div>
                {steps[step].title && <h4>Please complete the form to sign up: <b>{steps[step].title}</b></h4>}
                {isFullScreen && (step !== 'KYC' && step !== 'reviewInfo' && step !== 'approval') && <Stepper step={8} current={currentStep} />}
                {steps[step].component}
                {legalModal && <Legal />}
            </div>
        </Entrance>
    );
};

export default SignUpPage;
